
import { xCore } from './core';
import { NSControlsState } from './utils/controls_state';
import { NSFunctions } from './utils/functions';
import { NSCombos } from './utils/combos';
import { NSMessages } from './utils/messages';
import { NSServerCalls } from './utils/servercalls';
import { URN as NSURN } from './utils/urn';
import { NSGeoJson } from './utils/geojson';
import { NSPageLabels } from './page_labels';
import { NSDataModelInfo } from './data_model_info';
import { NSGroups } from './groups';
import { NSUserFunctionPermissions } from './user_function_permissions';
import { Map as Module_Map } from './map';
import { NSToolDraw } from './tool_draw';
import { Overlays as NSOverlays } from "./overlays";
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { NSCRS } from './utils/crs';
import	{ NSFeaturesSelect } from './map_features_select'
import {unByKey} from 'ol/Observable';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import { Fill, Icon, Stroke, Style, Text, Circle as CircleStyle, RegularShape } from 'ol/style';
import {Draw, Modify, Snap, Translate} from 'ol/interaction';
import {getLength} from 'ol/sphere';
import LineString from 'ol/geom/LineString';
import { get } from 'jquery';
import { scale } from 'ol/coordinate';

import PrinterIcon from 'bootstrap-icons/icons/printer.svg?raw'

export let NSPrint = {};


NSPrint.init = function()
{
	
	
	this.f_show = 	function () { return NSPrintPrivate.f_show.apply( NSPrintPrivate, arguments ); };
	this.f_hide = 	function () { return NSPrintPrivate.f_hide.apply( NSPrintPrivate, arguments ); };


	this.objs = NSPrintPrivate.objs;


	//window.NSPrint = NSPrint;
	window.NSPrint_ = NSPrint;
	window.NSPrintPrivate_ = NSPrintPrivate;
	
	
	let o_promise_result = new Promise((resolve, reject) => 
		{
		
			NSPrintPrivate.init( resolve );
		}
	);

    return o_promise_result;
	
};

let NSPrintPrivate =
{
    private_objs: {
		
		settings: null, //config settings

		s_e_div_print_holder_id: "printpage",
		e_div_print_holder: null,
        
		
		e_select_print_template: null,
		e_select_print_dpi: null,
		
		e_div_print_scale: null,
		e_select_print_scale: null,
		e_div_print_titulo: null,
		e_input_print_titulo: null,	
		e_div_print_referencia: null,
		e_input_print_referencia: null,
		
		
		e_button_print_execute: null,
		e_div_print_loading: null,
		e_span_print_messages: null,
		
		e_div_print_result: null,
		e_button_print_open: null,
		
		o_combo_template: null,
		o_combo_scale: null,
		
		o_marker_struct:
		{

            private_objs:{
                map: null,
                vector_source: null,        //VectorSource
                vector_layer: null,         //VectorLayer
                style: null,                //Openlayers Style
                style_modify: null,         //Openlayers Style

                modify: null,               // Modify

                b_marker_is_visible: false,
                o_center_marker: null,
            },


            init: function()
            {
                this.private_objs.map = Module_Map.f_get_map();

                let s_icon_url = xCore.application.images_base_path + "/print/print_centre.png";

                this.private_objs.style = new Style({
                    image: new Icon({
                        anchor: [0.5, 0.5],//anchor: [0.5, 1.0],
                        anchorXUnits: 'fraction',
                        anchorYUnits: 'fraction',
                        src: s_icon_url,
                    }),
                    /*
                    fill: new Fill({
                      color: '#ADD8E6'
                    }),
                    stroke: new Stroke({
                      color: '#880000',
                      width: 1
                    }),
                    */
                    fill: null,
                    stroke: null
                });

                this.private_objs.style_modify = new Style({
                    image: new CircleStyle({
                        radius: 20,//radius: 5,
                        stroke: new Stroke({
                        color: 'rgba(255, 0, 0, 0.7)', //'rgba(0, 0, 0, 0.7)',
                        //lineDash: [10, 10],
                        width: 7//3
                        }),
                        fill: new Fill({
                        color: 'rgba(255, 255, 255, 0.0)', //'rgba(255, 255, 255, 0.92)',
                        }),
                    })
                });

                this.private_objs.vector_source = new VectorSource(),
                this.private_objs.vector_layer = new VectorLayer({
                    source: this.private_objs.vector_source,
                    style: this.private_objs.style
                });
            },
			
			f_show: function ()
			{

                

                let private_objs = this.private_objs;
                let o_geojson_feature_geometry = NSGeoJson.f_get_geojson_feature_point_from_coords(Module_Map.f_get_map().getView().getCenter()).geometry;

                this.f_hide();

                let map = this.private_objs.map;
                let vector_source = this.private_objs.vector_source;
                let vector_layer = this.private_objs.vector_layer;
                map.addLayer(vector_layer);
                let modify = new Modify({source: vector_source, style: private_objs.style_modify});
                map.addInteraction(modify);

                let o_geojson_feature = NSGeoJson.f_get_geojson_feature_from_geojson_geometry(o_geojson_feature_geometry);
                let o_ol_feature = new GeoJSON().readFeature(o_geojson_feature);
                vector_source.addFeature(o_ol_feature);

				this.b_marker_is_visible = true;
				
			},
			f_hide: function()
			{
                let map = this.private_objs.map;

                map.removeInteraction(this.private_objs.modify);
                map.removeLayer(this.private_objs.vector_layer);
                
                this.private_objs.modify = null;
        
                this.f_clear_geometries();
        
				this.b_marker_is_visible = false;
			},

            f_clear_geometries: function()
            {
                this.private_objs.vector_source.clear();    //removes all features
            },
			/**
             * 
             * @returns {Array<Number>} an x y array; ex: [1.1, 2.2]
             */
			f_get_coords_a_xy: function()
			{
                let a_map_feature = this.private_objs.vector_source.getFeatures();
                let o_map_feature = (a_map_feature.length > 0) ? a_map_feature[0]: null;
                
                let a_xy = null;
                if(o_map_feature != null)
                {
                    let o_gj = ( o_map_feature != null ) ? new GeoJSON().writeFeatureObject(o_map_feature, {rightHanded: true}) : null;
                    a_xy = o_gj.geometry.coordinates;
            }


                return a_xy;
                
			},
			
			f_set_coords_a_xy: function(x, y)
			{
                let a_map_feature = this.private_objs.vector_source.getFeatures();
                let o_map_feature = (a_map_feature.length > 0) ? a_map_feature[0]: null;
                
                let a_xy = null;
                if(o_map_feature != null)
                {
					o_map_feature.getGeometry().setCoordinates([x, y]);
            	}
			}
		},
		
		
		
		o_data_struct: {

			a_template: null,
			dpi_default_value: null,
			
			init: function()
			{
				var o_settings = NSPrintPrivate.private_objs.settings;
				
				this.a_template = o_settings.a_template;

				this.dpi_default_value = o_settings.dpi_default_value;
				
			},
			
			//functions:
			f_get_a_template_desc: function()
			{
				var a_t_ = this.a_template;
				var a_template_desc = [];
				a_t_.forEach(function(o_i,i,a_){
					a_template_desc.push(o_i.external_name);
				});
				return a_template_desc;
			},
			f_get_a_template_key: function()
			{
				var a_t_ = this.a_template;
				var a_template_desc = [];
				a_t_.forEach(function(o_i,i,a_){
					a_template_desc.push(o_i.internal_name);
				});
				return a_template_desc;
			},
			f_get_a_dpi_desc: function()
			{
				let a_dpi = this.a_dpi;
				let a_dpi_desc = [];
				a_dpi.forEach(function(o_i,i,a_){
					a_dpi_desc.push(o_i);
				});
				return a_dpi_desc;
			},
			f_get_a_dpi_key: function()
			{
				let a_dpi = this.a_dpi;
				let a_dpi_key = [];
				a_dpi.forEach(function(o_i,i,a_){
					a_dpi_key.push(o_i);
				});
				return a_dpi_key;
			},
			f_get_dpi_default_key: function()
			{
				return this.dpi_default_value;
			},
			f_get_a_scale_desc: function()
			{
				var o_template = this.f_get_selected_template();
				
				var a_scale = o_template.a_scale;
				
				var a_s_ = a_scale;
				var a_scale_desc = [];
				a_s_.forEach(function(o_i,i,a_){
					a_scale_desc.push(o_i.external_name);
				});
				return a_scale_desc;
			},
			f_get_a_scale_key: function()
			{
				var o_template = this.f_get_selected_template();
				
				var a_scale = o_template.a_scale;
				
				var a_s_ = a_scale;
				var a_scale_key = [];
				a_s_.forEach(function(o_i,i,a_){
					a_scale_key.push(o_i.internal_name);
				});
				return a_scale_key;
			},
			f_get_template_by_key: function(s_key_template_internal_name)
			{
				var a_t_ = this.a_template;
				for(var i=0; i<a_t_.length; i++)
				{
					var o_i = a_t_[i];
					if(o_i.internal_name == s_key_template_internal_name)
					{
						return o_i;
					}
				}
				
				return null;
			},
			f_get_selected_template: function()
			{
				var s_template = NSPrintPrivate.private_objs.o_combo_template.getSelectedKey();
				var s_key_template_internal_name = s_template;
				var o_template = this.f_get_template_by_key(s_key_template_internal_name);
				return o_template;
			}
			
			
			
			
		},

		o_MafishMapBounds_struct: {

			private_objs:
			{
				CONST_mf_dpi: 72, //	dpi/ppi - dpi for page, not map content print
				CONST_inches_to_m_factor: (2.54/100),
				CONST_m_to_inches_factor: (0.39370079*100),

				CONST_epg_3857_meter_aproximation_cascais: 1.285,

				ENUM_HEADING: Object.freeze({
					NORTH: "north",
					SOUTH: "south",
					WEST: "west",
					EAST: "east"
				})
				
			},
	
			init: function()
			{
				let private_objs = this.private_objs;

				
			},

			f_get_distance_between_2_points: function(a_xy_1, a_xy_2)
			{
				let private_objs = this.private_objs;
				let CONST_mf_dpi = private_objs.CONST_mf_dpi;
				let CONST_inches_to_m_factor = private_objs.CONST_inches_to_m_factor;

				let a_line_string_coords = [];
				a_line_string_coords.push(a_xy_1);
				a_line_string_coords.push(a_xy_2);

				let opt_layout = null;
				let o_ls = new LineString(a_line_string_coords, opt_layout);

				let n_distance = getLength(o_ls);
				return n_distance;

			},

			/**
			 * 
			 * @param {Array<Number>} a_xy 
			 * @param {Number} n_target_distance_m  -> meters
			 * @param {NSPrintPrivate.private_objs.o_MafishMapBounds_struct.private_objs.ENUM_HEADING} enum_heading - "north || south || west || east"
			 * @returns {Array<number>} returns a_point_xy
			 */
			f_get_point_at_distance_on_axis_for_given_heading: function(a_xy, n_target_distance_m, enum_heading)
			{

				
				//console.log("enum_heading="+enum_heading);
				//console.log("n_target_distance_m="+n_target_distance_m);

				let private_objs = this.private_objs;
				let CONST_epg_3857_meter_aproximation_cascais = private_objs.CONST_epg_3857_meter_aproximation_cascais;
				

				let a_point_xy_2 = [].concat(a_xy);

				let i_array_index_of_axis_being_adjusted;	// 0 -> x; 1->y;
				let n_adjust_direction;				// 1 or -1	; 	1 -> Norh or West; -1 -> South or East
				if(enum_heading 		== this.private_objs.ENUM_HEADING.NORTH)
				{
					i_array_index_of_axis_being_adjusted = 1;
					n_adjust_direction = 1;
				}
				else if(enum_heading	== this.private_objs.ENUM_HEADING.SOUTH)
				{
					i_array_index_of_axis_being_adjusted = 1;
					n_adjust_direction = -1;
				}
				else if(enum_heading 	== this.private_objs.ENUM_HEADING.EAST)
				{
					i_array_index_of_axis_being_adjusted = 0;
					n_adjust_direction = 1;
				}
				else if(enum_heading	== this.private_objs.ENUM_HEADING.WEST)
				{
					i_array_index_of_axis_being_adjusted = 0;
					n_adjust_direction = -1;
				}

				//console.log("before initial aprox a_point_xy_2=" + a_point_xy_2);
				// Initial aproximation:
				a_point_xy_2[i_array_index_of_axis_being_adjusted] += ( (n_target_distance_m*CONST_epg_3857_meter_aproximation_cascais) *  n_adjust_direction);
				//console.log("after initial aprox a_point_xy_2=" + a_point_xy_2);

				let n_adjust_direction_changed_counter = 0; // 1 or -1
				let n_previous_delta_to_target_distance = n_target_distance_m;
				let a_previous_point_xy_2 = [].concat(a_point_xy_2);
				let n_adjust_amount = CONST_epg_3857_meter_aproximation_cascais;
				let b_keep_adjusting = true;

				let i_iteration_counter =0;
				while(b_keep_adjusting)
				{
					i_iteration_counter++;
					//console.log("i_iteration_counter="+i_iteration_counter);

					if(i_iteration_counter>1)
					{
						a_point_xy_2[i_array_index_of_axis_being_adjusted] += (n_adjust_amount *  n_adjust_direction);
					}

					let n_distance = this.f_get_distance_between_2_points(a_xy, a_point_xy_2);
					let n_delta_to_target_distance = Math.abs( n_target_distance_m - n_distance ); //allways positive

					//console.log("n_delta_to_target_distance="+n_delta_to_target_distance);

					if(i_iteration_counter > 50)
					{
						b_keep_adjusting = false;
						console.error("print.js - f_get_point_at_distance_on_axis_for_given_heading - inside loop could not find point - infinite loop?");
						break;
					}

					if (n_delta_to_target_distance < 0.2) // if distance is this small point is good enough!
					{
						b_keep_adjusting = false;
					}
					if (n_delta_to_target_distance < 1)
					{
						n_adjust_amount = CONST_epg_3857_meter_aproximation_cascais/10;
					}
					
					if(n_previous_delta_to_target_distance < n_delta_to_target_distance)	// going the wrong way
					{
						n_adjust_direction *= -1;			// invert direction
						n_adjust_direction_changed_counter ++;

						//undo last adjustment
						a_point_xy_2 = [].concat(a_previous_point_xy_2);

					}
					else									// going in the right way
					{
						a_previous_point_xy_2 = [].concat(a_point_xy_2);
						n_previous_delta_to_target_distance = n_delta_to_target_distance;
					}

					if(n_adjust_direction_changed_counter>1)	// going over target by too much distance
					{
						n_adjust_amount /= 2;					// reducing adjust/jump size
						n_adjust_direction_changed_counter = 0;	// reseting
					}


				}

				//console.log("NSPrintPrivate...f_get_point_at_distance_on_axis_for_given_heading - iterations number="+i_iteration_counter);

				return a_point_xy_2;
				

			},
	
			/*
				a_print_center_xy = NSPrintPrivate_.private_objs.o_marker_struct.f_get_coords_a_xy();

				NSPrintPrivate_.private_objs.o_MafishMapBounds_struct.f_get_bbox_in_mapfish_in_EPSG3857(2000, 530, 600);
			*/
			/**
			 * 
			 * @param {Array<Number>} a_center_xy 
			 * @param {Integer} i_scale		-> ex: 2000 represents 1:2000
			 * @param {Number} i_map_width	-> pixels
			 * @param {Number} i_map_height	-> pixels
			 * 
			 * @returns {Array<Number>} [ x_min, y_min, x_max, y_max ] //EPSG3857
			 */
			f_get_bbox_in_mapfish_in_EPSG3857: function(i_scale, i_map_width, i_map_height)
			{
				let private_objs = this.private_objs;
				let CONST_mf_dpi = private_objs.CONST_mf_dpi;
				let CONST_inches_to_m_factor = private_objs.CONST_inches_to_m_factor;
				
	
				//real dimensions on paper a few cms 
				let width_m_on_paper = (i_map_width / CONST_mf_dpi) * CONST_inches_to_m_factor;
				let height_m_on_paper = (i_map_height / CONST_mf_dpi) * CONST_inches_to_m_factor;

				//corresponding dimensions in real life
				let width_m_real_life = width_m_on_paper * i_scale;
				let height_m_real_life = height_m_on_paper * i_scale;
	
	
				let a_print_center_xy = NSPrintPrivate.private_objs.o_marker_struct.f_get_coords_a_xy();

				let n_bbox_x_distance = width_m_real_life / 2;
				let n_bbox_y_distance = height_m_real_life / 2;

				let a_point_x_max = this.f_get_point_at_distance_on_axis_for_given_heading(a_print_center_xy, n_bbox_x_distance, this.private_objs.ENUM_HEADING.EAST);
				let a_point_x_min = this.f_get_point_at_distance_on_axis_for_given_heading(a_print_center_xy, n_bbox_x_distance, this.private_objs.ENUM_HEADING.WEST);
				let a_point_y_max = this.f_get_point_at_distance_on_axis_for_given_heading(a_print_center_xy, n_bbox_y_distance, this.private_objs.ENUM_HEADING.NORTH);
				let a_point_y_min = this.f_get_point_at_distance_on_axis_for_given_heading(a_print_center_xy, n_bbox_y_distance, this.private_objs.ENUM_HEADING.SOUTH);

				let a_bbox = [
					a_point_x_min[0],
					a_point_y_min[1],
					a_point_x_max[0],
					a_point_y_max[1]
				];

				return a_bbox;

			}
		}
		
		
		
		
	},

    init: function(f_cb_in)
	{
		let private_objs = this.private_objs;
		let moduleName = "NSPrint";
		private_objs.settings = xCore.modules[moduleName].settings;
		
		this.objs.init();

        private_objs.o_marker_struct.init();
		private_objs.o_data_struct.init();
		
		private_objs.e_div_print_holder = document.getElementById(private_objs.s_e_div_print_holder_id);
		
		
		this.f_create_page_html();
		
		this.f_create_quickprint_button();

		this.o_servercalls.f_get_print_capabilities(f_cb_in);

	},
	
	f_show: function()
	{
		this.private_objs.o_marker_struct.f_show();
	},
	f_hide: function()
	{
		this.private_objs.o_marker_struct.f_hide();
	},
	
	f_show_print_loading: function()
	{
		this.private_objs.e_div_print_loading.style.display = "";
	},
	f_hide_print_loading: function()
	{
		this.private_objs.e_div_print_loading.style.display = "none";
	},
	
	
	f_create_page_html: function()
	{
		var this_ = this;
		var private_objs = this.private_objs;

        let s_print_page_title = NSPageLabels.f_get_label_text_by_internal_name("print_page_title");
		let s_print_button_excute_tooltip = NSPageLabels.f_get_label_text_by_internal_name("print_button_excute_tooltip");
		let s_print_title = NSPageLabels.f_get_label_text_by_internal_name("print_title");
		let s_print_span_info = NSPageLabels.f_get_label_text_by_internal_name("print_span_info");
		let s_print_combobox_template = NSPageLabels.f_get_label_text_by_internal_name("print_combobox_template");
		let s_print_combobox_scale = NSPageLabels.f_get_label_text_by_internal_name("print_combobox_scale");
		let s_print_input_title = NSPageLabels.f_get_label_text_by_internal_name("print_input_title");
		let s_print_input_reference = NSPageLabels.f_get_label_text_by_internal_name("print_input_reference");
		
        var s_html = `
			<div class="page-title">${s_print_page_title}</div>
			<div class="page-content">
				<div class="page-card">
					<div class="title">${s_print_title}</div>
					<div class="details">${s_print_span_info}</div>
					<div class="form">
						<div class="row g-0">
							<div class="col-12 col-sm-4">	
								<span for="select_print_template">${s_print_combobox_template}: </span>
							</div>
							<div class="col-12 col-sm-8">	
								<select id="select_print_template" class="form-select form-select-sm"></select>
							</div>
						</div>
						<div id="div_print_scale" class="row g-0">
							<div class="col-12 col-sm-4">	
								<span for="select_print_scale">${s_print_combobox_scale}: </span>
							</div>
							<div class="col-12 col-sm-8">	
								<select id="select_print_scale" class="form-select form-select-sm"></select>
							</div>
						</div>
						<div id="div_print_titulo" class="row g-0">
							<div class="col-12 col-sm-4">	
								<span for="input_print_titulo">${s_print_input_title}: </span>
							</div>
							<div class="col-12 col-sm-8">	
								<input id="input_print_titulo" type="text" placeholder="" class="form-control form-control-sm">
							</div>
						</div>
						<div id="div_print_referencia" class="row g-0">
							<div class="col-12 col-sm-4">	
								<span for="input_print_referencia">${s_print_input_reference}: </span>
							</div>
							<div class="col-12 col-sm-8">	
								<input id="input_print_referencia" type="text" placeholder="" class="form-control form-control-sm">
							</div>
						</div>
					</div>
					<div class="actions">	
						<div id="div_print_result">
							<button id="button_print_open" type="button" class="btn btn-danger " title="" ><span class=""><b>Abrir</b></span></button>
						</div>
						<div id="div_print_loading" class="spinner-border text-danger" role="status"></div>
						<button id="button_print_execute" type="button" class="btn btn-sm btn-outline-secondary" title="${s_print_button_excute_tooltip}">
							${PrinterIcon}
						</button>
					</div>
				</div>
			</div>
		`;


        NSFunctions.f_dom_elem_append_dom_childs_by_html(private_objs.e_div_print_holder, s_html);
		
		private_objs.e_select_print_template = document.getElementById("select_print_template");
		
		private_objs.e_div_print_scale = document.getElementById("div_print_scale");
		private_objs.e_select_print_scale = document.getElementById("select_print_scale");
		
		private_objs.e_div_print_titulo = document.getElementById("div_print_titulo");
		private_objs.e_input_print_titulo = document.getElementById("input_print_titulo");
		
		private_objs.e_div_print_referencia = document.getElementById("div_print_referencia");
		private_objs.e_input_print_referencia = document.getElementById("input_print_referencia");
		
		private_objs.e_select_print_dpi = document.getElementById("select_print_dpi");
		
		
		private_objs.e_button_print_execute = document.getElementById("button_print_execute");
		private_objs.e_div_print_loading = document.getElementById("div_print_loading");
		private_objs.e_span_print_messages = document.getElementById("span_print_messages");
		
		private_objs.e_div_print_result = document.getElementById("div_print_result");
		private_objs.e_button_print_open = document.getElementById("button_print_open");
		
		private_objs.e_button_quickprint = document.getElementById("button_quickprint");
		
		this.f_hide_result_div();
		this.f_hide_print_loading();
	
	
		this.f_initialize_combos();
		
		private_objs.e_button_print_execute.onclick = function(){  this_.f_execute_print(); };
		
		
	},

    
	f_initialize_combos: function()
	{
		var this_ = this;
		
		var private_objs = this.private_objs;
		
		var f_onSelect_template_CB = function(s_key)
		{
			this_.f_onSelect_template(s_key);
		};
		
		var f_onSelect_scale_CB = function(s_key)
		{
			this_.f_onSelect_scale(s_key);
		};

		var s_id_select_print_template = private_objs.e_select_print_template.getAttribute("id"); //"select_print_template";
		private_objs.o_combo_template =  new NSCombos.objs.Combo(s_id_select_print_template, f_onSelect_template_CB, [], null);
		
		var s_id_select_print_scale = private_objs.e_select_print_scale.getAttribute("id"); //"select_print_template";
		private_objs.o_combo_scale =  new NSCombos.objs.Combo(s_id_select_print_scale, f_onSelect_scale_CB, [], null);
		
		
		var a_template_desc = private_objs.o_data_struct.f_get_a_template_desc();
		var a_template_key = private_objs.o_data_struct.f_get_a_template_key();
				
		private_objs.o_combo_template.reset(a_template_desc, a_template_key);
	},
	f_onSelect_template: function(s_key)
	{
		var this_ = this;
		
		var private_objs = this.private_objs;
		
		var a_scale_desc = private_objs.o_data_struct.f_get_a_scale_desc();
		var a_scale_key = private_objs.o_data_struct.f_get_a_scale_key();
		
		a_scale_desc = (a_scale_desc != null)? a_scale_desc : [];
		a_scale_key = (a_scale_key != null)? a_scale_key : [];
		
		private_objs.o_combo_scale.reset(a_scale_desc, a_scale_key);
		
		var b_show_scale_combo = (a_scale_key.length > 1)? true : false;
		
		var o_template = private_objs.o_data_struct.f_get_selected_template();
				
		//var a_scale = o_template.a_scale;
		//var b_area_is_required = o_template.b_area_is_required;
		var b_use_attributes__titulo_referencia = o_template.b_use_attributes__titulo_referencia;
	
		if(b_show_scale_combo)
		{
			this.f_show_scale_div();
		}
		else
		{
			this.f_hide_scale_div();
		}
		
		if(b_use_attributes__titulo_referencia)
		{
			this.f_show_titulo_referencia_divs();
		}
		else
		{
			this.f_hide_titulo_referencia_divs();
		}
	
		
	},
	f_onSelect_scale: function(s_key)
	{
		
	},
	

    f_execute_print: function()
	{
		
		var this_ = this;
		
		var b_button_active = this.f_button_execute_is_enabled();
		
		if (!b_button_active)
		{
			return;
		}
		
		this.f_button_execute_disable();
		
		this.f_hide_result_div();
		
		var b_input_is_valid = this.f_validate();
		
		
		if (b_input_is_valid)			
		{
			var f_cb = function(o_res)
			{
				this_.f_button_execute_enable();
				this_.f_hide_print_loading();
				
			};
			
			this.f_show_print_loading();
			this.f_execute_print_part_2(f_cb);
			
		}
		else
		{
			this_.f_button_execute_enable();
		}
		
	},
	
	f_execute_print_part_2: function(f_cb_in)
	{
		
		var this_ = this;
		
		var private_objs = this.private_objs;
		//var o_data_struct = private_objs.o_data_struct;
		
		NSPrintPrivate.o_servercalls.f_execute_print(f_cb_in);
		
		
		
	},


    

	o_servercalls: {
		private_objs: {
			s_CONST_GEOSERVER_WORKSPACE: "GeoCascais",
			s_CONST_STYLE_TYPE_PROPRIETY_NAME: "style_type",
			s_CONST_STYLE_TYPE_POINT_VALUE: "point",
			s_CONST_STYLE_TYPE_LINE_VALUE: "line",
			s_CONST_STYLE_TYPE_POLYGON_VALUE: "polygon",
			s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME: "prop_name_of_label_value"

		},

		f_get_print_capabilities: function(f_cb_in)
		{
			/*
				f_print_get_capabilities: function()
				@returns promise object (handle_resolve(o_resp)) => o_resp is a json object
    		*/
			let o_promise = NSServerCalls.f_print_get_capabilities();
			o_promise.then( (o_resp) => {

				let a_single_map_prints = ["A4 portrait", "A4 landscape", "A3 portrait", "A3 landscape"]
				let a_template = NSPrintPrivate.private_objs.o_data_struct.a_template;
				a_template.forEach((o_template)=>
				{
					let s_internal_name = o_template.internal_name;
					let o_layout = o_resp.layouts.find( o_layout => o_layout.name == s_internal_name );
					
					if( a_single_map_prints.indexOf(s_internal_name) > -1 )
					{
						let o_attribute_map = o_layout.attributes.find( o_attribute => o_attribute.name == "map" );
						o_template.mapfish = {
							map_height: o_attribute_map.clientInfo.height,
							map_width: o_attribute_map.clientInfo.width
						};

					}
					else if (s_internal_name == "Planta localizacao")
					{
						let o_attribute_map01Def = o_layout.attributes.find( o_attribute => o_attribute.name == "map01Def" );
						let o_attribute_map02Def = o_layout.attributes.find( o_attribute => o_attribute.name == "map02Def" );
						o_template.mapfish = {
							map01_height: o_attribute_map01Def.clientInfo.height,
							map01_width: o_attribute_map01Def.clientInfo.width,
							map02_height: o_attribute_map02Def.clientInfo.height,
							map02_width: o_attribute_map02Def.clientInfo.width
						};
						
					}
					else if (s_internal_name == "PDM template")
					{
						const s_CONST_MAPFISH_ATTRIBUTES_MAP_TYPE = 'MapAttributeValues'; 
						
						//First map has the same size as all the others
						let o_attribute_map = o_layout.attributes.find( o_attribute => o_attribute.type == s_CONST_MAPFISH_ATTRIBUTES_MAP_TYPE );
						
						o_template.mapfish = {
							map_height: o_attribute_map.clientInfo.height,
							map_width: o_attribute_map.clientInfo.width
						};
					}


					
				});


				f_cb_in();
			});
		},

		f_execute_print(f_cb_in)
		{

			let o_data_struct = NSPrintPrivate.private_objs.o_data_struct;			
			let o_template = o_data_struct.f_get_selected_template();
			let s_template_internal_name = o_template.internal_name;

			let o_data_in = this.f_create_o_print_data_in();
			let o_promise;
			if(s_template_internal_name == "PDM template")
			{
				/*
					f_print_pdm: function(o_data_in)
					@returns promise object (handle_resolve(o_resp)) => o_resp is a json object
				*/
				o_promise = NSServerCalls.f_print_pdm(o_data_in);
			}
			else //Normal Print Call
			{
				/*
					f_print: function(o_data_in)
					@returns promise object (handle_resolve(o_resp)) => o_resp is a json object
				*/
				o_promise = NSServerCalls.f_print(o_data_in);
			}
			o_promise.then( (blob) => {
				const FILE_NAME = "print.pdf";

				let fileURL = window.URL.createObjectURL(blob);
				const anchor = document.createElement("a");
				anchor.href = fileURL;
				anchor.download = FILE_NAME;

				document.body.appendChild(anchor);
				anchor.click();
				document.body.removeChild(anchor);

				f_cb_in();
			});


		},
		f_create_o_print_data_in: function()
		{

			let o_data_struct = NSPrintPrivate.private_objs.o_data_struct;			
			let o_template = o_data_struct.f_get_selected_template();
			let b_normal_print = o_template.b_normal_print;
			let s_template_internal_name = o_template.internal_name;
			
			let o_print_data_in;

			if(b_normal_print) // "A4 portrait", "A4 landscape", "A3 portrait", "A3 landscape"
			{
				o_print_data_in = this.f_create_o_print_data_in_for_normal_print();
			}
			else if(s_template_internal_name == "Planta localizacao")
			{
				let a_center = NSToolDraw.f_get_drawn_polygon_center();
				NSPrintPrivate_.private_objs.o_marker_struct.f_set_coords_a_xy(a_center[0], a_center[1]);

				o_print_data_in = this.f_create_o_print_data_in_for_planta_localizacao_print();				
			}
			else if(s_template_internal_name == "PDM template")
			{
				let a_center = NSToolDraw.f_get_drawn_polygon_center();
				NSPrintPrivate_.private_objs.o_marker_struct.f_set_coords_a_xy(a_center[0], a_center[1]);

				o_print_data_in = this.f_create_o_print_data_in_for_pdm_print();
			}
			



			return o_print_data_in;
		},

		/**
		 @summary for print one of the following type: "A4 portrait", "A4 landscape", "A3 portrait", "A3 landscape"
		 */
		f_create_o_print_data_in_for_normal_print: function()
		{
			let private_objs_global = NSPrintPrivate.private_objs;

			let o_data_struct = NSPrintPrivate.private_objs.o_data_struct;			
			let o_template = o_data_struct.f_get_selected_template();
			//let b_normal_print = o_template.b_normal_print;
			let b_use_attributes__titulo_referencia = o_template.b_use_attributes__titulo_referencia;
			let b_use_selected_object = o_template.b_use_selected_object;
			//let b_area_is_required = o_template.b_area_is_required;
			let b_use_client_themes = o_template.b_use_client_themes;
			let b_use_drawn_geometry = o_template.b_use_drawn_geometry;
			
			let a_center = NSPrintPrivate.private_objs.o_marker_struct.f_get_coords_a_xy();
			//Avoiding Cache:
			let num = parseFloat(a_center[1]);
			num = num + ( (Math.floor(Math.random()*1000)) * 0.000000000000001);
			a_center[1] = num ;//num.toString();


			//let a_base_layers = this.f_get_base_layers_array();
			let a_selected_layers = (b_use_client_themes)?		this.f_get_selected_layers_array(): [];
			let a_geojson_tooldraw = (b_use_drawn_geometry)?	this.f_get_tooldraw_mapfish_geojson_layers_array() : [];


			let b_use_highlights = true;
			let a_geojson_highlighted = (b_use_highlights)?	this.f_get_objs_highlighted_mapfish_geojson_layers_array() : [];


			// ATENTION ORDER IS IMPORTANT! HEAD ELEMENTS WILL BE ON TOP (and hiding) OF TAIL ELEMENTS
			//let a_layers = [].concat(a_geojson_tooldraw, a_selected_layers, a_base_layers);
			let a_layers = [].concat(a_geojson_tooldraw, a_geojson_highlighted, a_selected_layers);

			
			let s_output_file_name = "print.pdf";
			/*
			let s_layout = "A4 portrait";
			let s_map_title = "Titulo da Impressão";
			let s_scale_label_value = "1:2000";
			let i_scale_value = 2000;
			let a_center_xy = [-1048618.3509276763, 4678366.797897691];
			let i_dpi = 72;
			*/
			let s_layout = o_template.internal_name;
			let i_scale_value = private_objs_global.o_combo_scale.getSelectedKey();
			let s_scale_label_value = "1:"+i_scale_value;
			let a_center_xy = a_center;
			let i_dpi = private_objs_global.o_data_struct.f_get_dpi_default_key();
			let i_map_height = o_template.mapfish.map_height
			let i_map_width = o_template.mapfish.map_width

			
			/**
			 * 
			 * @param {Array<Number>} a_center_xy 
			 * @param {Integer} i_scale		-> ex: 2000 represents 1:2000
			 * @param {Number} i_map_width	-> pixels
			 * @param {Number} i_map_height	-> pixels
			 * 
			 * @returns {Array<Number> [ x_min, y_min, x_max, y_max ] //EPSG3857
			 */
			 let a_bbox = NSPrintPrivate.private_objs.o_MafishMapBounds_struct.f_get_bbox_in_mapfish_in_EPSG3857(i_scale_value, i_map_width, i_map_height);
			 let a_xy_max = a_bbox.slice(2);
			 /*
			 //	EPSG:3857
			 //
			 let a_center_etrs89 = [];
			 let proj4 = proj4_mod_name;
			 let source = 'EPSG:3857'; // EPSG:3857
			 //let secondProjection = "+proj=gnom +lat_0=90 +lon_0=0 +x_0=6300000 +y_0=6300000 +ellps=WGS84 +datum=WGS84 +units=m +no_defs";
			 let etrs89__projection = "+proj=tmerc +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ";
 
			 // (source, destiny, coords)
			 a_center_etrs89 = proj4(source,etrs89__projection, a_center);
			 */
			 let i_dp = 0; // decimal places
			 let a_xy_max_etrs89 = NSCRS.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP(a_xy_max, i_dp);
 
			 let s_xy_max_etrs89_x_formated = a_xy_max_etrs89[0] + " m";
			 let s_xy_max_etrs89_y_formated = a_xy_max_etrs89[1] + " m";




			let o_print_data_in = {
				"layout": s_layout,
				"outputFilename": s_output_file_name,
				"attributes": {
					//"mapTitle": s_map_title + " 02",
					"scale_label_value": s_scale_label_value,
					"map": {
						"rotation": 0,
						"center": a_center_xy,
						"layers": a_layers,
						"scale": i_scale_value,
						"projection": "EPSG:3857",
						"dpi": i_dpi
					}
				}
			};

			if(o_template.b_use_attributes__titulo_referencia)
			{
				let s_map_title = private_objs_global.e_input_print_titulo.value;
				let s_referencia = private_objs_global.e_input_print_referencia.value;
				
				o_print_data_in.attributes["mapTitle"] = s_map_title;

				o_print_data_in.attributes["attributeReference"] = s_referencia;


			}

			o_print_data_in.attributes["bb_max_x_etrs89_pt_tm06"] = s_xy_max_etrs89_x_formated;
			o_print_data_in.attributes["bb_max_y_etrs89_pt_tm06"] = s_xy_max_etrs89_y_formated;


			return o_print_data_in;
		},

		/**
		 @summary for print one of the following type: "A4 portrait", "A4 landscape", "A3 portrait", "A3 landscape"
		 */
		f_create_o_print_data_in_for_planta_localizacao_print: function()
		{
			let private_objs_global = NSPrintPrivate.private_objs;

			let o_data_struct = NSPrintPrivate.private_objs.o_data_struct;			
			let o_template = o_data_struct.f_get_selected_template();
			//let b_normal_print = o_template.b_normal_print;
			let b_use_attributes__titulo_referencia = o_template.b_use_attributes__titulo_referencia;
			let b_use_selected_object = o_template.b_use_selected_object;
			//let b_area_is_required = o_template.b_area_is_required;
			let b_use_client_themes = o_template.b_use_client_themes;
			let b_use_drawn_geometry = o_template.b_use_drawn_geometry;

			
			let a_center = NSPrintPrivate.private_objs.o_marker_struct.f_get_coords_a_xy();
			//Avoiding Cache:
			let num = parseFloat(a_center[1]);
			num = num + ( (Math.floor(Math.random()*1000)) * 0.000000000000001);
			a_center[1] = num ;//num.toString();


			//let a_base_layers = this.f_get_base_layers_array();
			//let a_selected_layers = (b_use_client_themes)?		this.f_get_selected_layers_array(): [];
			let a_mapfish_layer_geojson_tooldraw = 					this.f_get_tooldraw_mapfish_geojson_layers_array();
			let a_mapfish_layer_geojson_area_center = 				this.f_get_area_center_mapfish_geojson_layers_array_for_planta_localizacao();
			let o_tooldraw_points__and__project_coords = 			this.f_get_tooldraw_area_points_mapfish_geojson_layers_array__and__project_coords_for_planta_localizacao();
			
			let a_area_point_mapfish_gj_layer = o_tooldraw_points__and__project_coords.a_area_point_mapfish_gj_layers;
			let s_project_coords = o_tooldraw_points__and__project_coords.project_coords;

			// ATENTION ORDER IS IMPORTANT! HEAD ELEMENTS WILL BE ON TOP (and hiding) OF TAIL ELEMENTS
			let a_layers_for_map01 = [].concat(a_mapfish_layer_geojson_area_center);
			let a_layers_for_map02 = [].concat(a_area_point_mapfish_gj_layer, a_mapfish_layer_geojson_tooldraw);

			let i_dp = 1;
			let o_area_perimeter = NSToolDraw.f_get_drawn_polygon_area_and_perimeter(i_dp);

			
			let s_output_file_name = "print.pdf";
			
			let s_layout = o_template.internal_name;
			let i_scale_value = private_objs_global.o_combo_scale.getSelectedKey();
			let s_scale_label_value = "1:"+i_scale_value;
			let a_center_xy = a_center;
			let i_dpi = private_objs_global.o_data_struct.f_get_dpi_default_key()

			let s_project_perimeter = o_area_perimeter.length;
			let s_project_area = o_area_perimeter.area;

			let o_print_data_in = {
				"layout": s_layout,
				"outputFilename": s_output_file_name,
				"attributes": {
					//"mapTitle": s_map_title + " 02",
					"scale_label_value": s_scale_label_value,
					"map01Def": {
						"rotation": 0,
						"center": a_center_xy,
						"layers": a_layers_for_map01,
						//"scale": i_scale_value,
						"projection": "EPSG:3857",
						"dpi": i_dpi
					},
					"map02Def": {
						"rotation": 0,
						"center": a_center_xy,
						"layers": a_layers_for_map02,
						"scale": i_scale_value,
						"projection": "EPSG:3857",
						"dpi": i_dpi
					},
					"project_coords": s_project_coords,
					"project_perimeter": s_project_perimeter,
					"project_area": s_project_area
				}
			};


			return o_print_data_in;
		},

		/**
		 @summary for print one of the following type: "A4 portrait", "A4 landscape", "A3 portrait", "A3 landscape"
		 */
		f_create_o_print_data_in_for_pdm_print: function()
		{
			let private_objs_global = NSPrintPrivate.private_objs;

			let o_data_struct = NSPrintPrivate.private_objs.o_data_struct;			
			let o_template = o_data_struct.f_get_selected_template();
			//let b_normal_print = o_template.b_normal_print;
			let b_use_attributes__titulo_referencia = o_template.b_use_attributes__titulo_referencia;
			let b_use_selected_object = o_template.b_use_selected_object;
			//let b_area_is_required = o_template.b_area_is_required;
			let b_use_client_themes = o_template.b_use_client_themes;
			let b_use_drawn_geometry = o_template.b_use_drawn_geometry;

			
			let a_center = NSPrintPrivate.private_objs.o_marker_struct.f_get_coords_a_xy();
			//Avoiding Cache:
			let num = parseFloat(a_center[1]);
			num = num + ( (Math.floor(Math.random()*1000)) * 0.000000000000001);
			a_center[1] = num ;//num.toString();

			let a_mapfish_layer_geojson_tooldraw = 					this.f_get_tooldraw_mapfish_geojson_layers_array();
			
			// ATENTION ORDER IS IMPORTANT! HEAD ELEMENTS WILL BE ON TOP (and hiding) OF TAIL ELEMENTS
			let a_layers_for_mapDef = [].concat(a_mapfish_layer_geojson_tooldraw);


			let s_output_file_name = "print.pdf";
			
			let s_layout = o_template.internal_name;
			let i_scale_value = private_objs_global.o_combo_scale.getSelectedKey();
			let s_scale_label_value = "1:"+i_scale_value;
			let a_center_xy = a_center;
			let i_dpi = private_objs_global.o_data_struct.f_get_dpi_default_key();
			let i_map_height = o_template.mapfish.map_height
			let i_map_width = o_template.mapfish.map_width


			/**
			 * 
			 * @param {Array<Number>} a_center_xy 
			 * @param {Integer} i_scale		-> ex: 2000 represents 1:2000
			 * @param {Number} i_map_width	-> pixels
			 * @param {Number} i_map_height	-> pixels
			 * 
			 * @returns {Array<Number> [ x_min, y_min, x_max, y_max ] //EPSG3857
			 */
			 let a_bbox = NSPrintPrivate.private_objs.o_MafishMapBounds_struct.f_get_bbox_in_mapfish_in_EPSG3857(i_scale_value, i_map_width, i_map_height);
			 let a_xy_max = a_bbox.slice(2);
			 let a_xy_min = a_bbox.slice(0, 2);
			 /*
			 //	EPSG:3857
			 //
			 let a_center_etrs89 = [];
			 let proj4 = proj4_mod_name;
			 let source = 'EPSG:3857'; // EPSG:3857
			 //let secondProjection = "+proj=gnom +lat_0=90 +lon_0=0 +x_0=6300000 +y_0=6300000 +ellps=WGS84 +datum=WGS84 +units=m +no_defs";
			 let etrs89__projection = "+proj=tmerc +lat_0=39.66825833333333 +lon_0=-8.133108333333334 +k=1 +x_0=0 +y_0=0 +ellps=GRS80 +units=m +no_defs ";
 
			 // (source, destiny, coords)
			 a_center_etrs89 = proj4(source,etrs89__projection, a_center);
			 */
			 let i_dp = 0; // decimal places
			 let a_xy_max_etrs89 = NSCRS.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP(a_xy_max, i_dp);
			 let a_xy_min_etrs89 = NSCRS.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP(a_xy_min, i_dp);
 
			 let s_xy_max_etrs89_x_formated = a_xy_max_etrs89[0] + " m";
			 let s_xy_max_etrs89_y_formated = a_xy_max_etrs89[1] + " m";
			 let s_xy_min_etrs89_x_formated = a_xy_min_etrs89[0] + " m";
			 let s_xy_min_etrs89_y_formated = a_xy_min_etrs89[1] + " m";


			let o_print_data_in = {
				"layout": s_layout,
				"outputFilename": s_output_file_name,
				"attributes": {
					//"mapTitle": s_map_title + " 02",
					"map_scale_label_value": s_scale_label_value,
					"mapDef": {
						"rotation": 0,
						"center": a_center_xy,
						"layers": a_layers_for_mapDef,
						"scale": i_scale_value,
						"projection": "EPSG:3857",
						"dpi": i_dpi
					},
					"bb_min_x_etrs89_pt_tm06": s_xy_min_etrs89_x_formated,
					"bb_min_y_etrs89_pt_tm06": s_xy_min_etrs89_y_formated,
					"bb_max_x_etrs89_pt_tm06": s_xy_max_etrs89_x_formated,
					"bb_max_y_etrs89_pt_tm06": s_xy_max_etrs89_y_formated
				}
			};


			return o_print_data_in;

		},

		f_get_base_layers_array: function()
		{
			let s_CONST_GEOSERVER_WORKSPACE = this.private_objs.s_CONST_GEOSERVER_WORKSPACE;

			let s_geoserver_internal_base_url = xCore.application.endpoints.geoserver_internal_base_url;
			let s_geoserver_base_wms_url = s_geoserver_internal_base_url + "/" + s_CONST_GEOSERVER_WORKSPACE + "/wms";

			return [
				{
					"imageFormat": "image/png",
					"baseURL": s_geoserver_base_wms_url,
					"customParams": {"TRANSPARENT": "true"},
					"layers": [s_CONST_GEOSERVER_WORKSPACE+":cartografia_base_2024"],
					"styles": [""],
					"opacity": 1,
					"type": "WMS"
				}
			];


		},

		f_get_selected_layers_array: function()
		{
			let s_CONST_GEOSERVER_WORKSPACE = this.private_objs.s_CONST_GEOSERVER_WORKSPACE;

			let s_geoserver_internal_base_url = xCore.application.endpoints.geoserver_internal_base_url;
			let s_geoserver_base_wms_url = s_geoserver_internal_base_url + "/" + s_CONST_GEOSERVER_WORKSPACE + "/wms";

			let a_selected_layers = [];

			let o_unique_geoserver_layer_names = [];

			NSOverlays.f_get_all_active_overlays().forEach( elem=>{
				if(elem.tree_node.geo_server_layer_name != null && elem.tree_node.geo_server_layer_name != "")
				{
					o_unique_geoserver_layer_names[elem.tree_node.geo_server_layer_name] = elem.tree_node.geo_server_layer_name;
				}
				else
				{
					let s_urn_table_name = NSURN.f_get_urn_table_name(elem.tree_node.urn);
					o_unique_geoserver_layer_names[s_urn_table_name] = s_urn_table_name;
				}
			});

			let a_unique_geoserver_layer_names = Object.keys(o_unique_geoserver_layer_names);

			let s_base_layer_internal_name = Module_Map.if_orto_get_current_basemap_layer_internal_name();
			if(s_base_layer_internal_name!=null && s_base_layer_internal_name != '')
			{
				/* 
					Order is important for base map to be at the bottom of the print 
					must be at the end/tail of the array
				*/
				a_unique_geoserver_layer_names.push(s_base_layer_internal_name);

			}

			a_unique_geoserver_layer_names.forEach( (s_geoserver_layer_name_i) =>
			{
				a_selected_layers.push(
					{
						"imageFormat": "image/png",
						"baseURL": s_geoserver_base_wms_url,
						"customParams": {"TRANSPARENT": "true"},
						"layers": [s_CONST_GEOSERVER_WORKSPACE+":"+s_geoserver_layer_name_i],
						"styles": [""],
						"opacity": 1,
						"type": "WMS"
					}
					
				);
			});

			return a_selected_layers;


		},
		f_get_tooldraw_mapfish_geojson_layers_array: function ()
		{
			let a_tooldraw_mapfish_gj_layers = [];

			let o_geojson = {
				"type": "FeatureCollection",
				"features": []
			};

			let o_geojson_feature = NSToolDraw.f_get_drawn_geometry_as_geo_json_feature();
			if (o_geojson_feature != null)
			{
				this.f_prepare_feature_for_style_standard(o_geojson_feature);
				o_geojson.features.push(o_geojson_feature);
				
				let o_style = this.f_get_mapfish_geojson_style_standard();
	
				let o_mapfish_geojson_layer = {
					geoJson: o_geojson,
					style: o_style,
					type: "geojson"
				};
				a_tooldraw_mapfish_gj_layers.push(o_mapfish_geojson_layer);
			}


			return a_tooldraw_mapfish_gj_layers;
		},
		f_get_objs_highlighted_mapfish_geojson_layers_array: function ()
		{
			let a_objs_highlighted_mapfish_gj_layers = [];

			let o_geojson = {
				"type": "FeatureCollection",
				"features": []
			};

			/*
				[
					{
						"geojson": {..},
						"style_simple": {..}
					}, ...
				]
			*/
			let a_highligtedGJAndStyles = NSFeaturesSelect.f_getHighlightedGeoJsonAndStyles();
			if(a_highligtedGJAndStyles!= null && a_highligtedGJAndStyles.length>0)
			{
				let a_point_highlight_vertical_offsets = [];
				a_highligtedGJAndStyles.forEach(elem => {
					
					let verticalOffset = 0;
					if(elem.style_simple.b_add_displacement_to_highlight_an_icon)
					{
						verticalOffset = elem.style_simple.a_icon_size_xy[1]/2;
						if (!a_point_highlight_vertical_offsets.includes(verticalOffset)) {
							a_point_highlight_vertical_offsets.push(verticalOffset);
						}

					}
					
					let o_gj_feature = elem.geojson;
					
					this.f_prepare_feature_for_style_for_highlights(o_gj_feature
						, elem.style_simple.b_add_displacement_to_highlight_an_icon,
						verticalOffset);

					o_geojson.features.push(o_gj_feature);
					
				});

				let o_style = this.f_get_mapfish_geojson_style_highlights(a_point_highlight_vertical_offsets);

				let o_mapfish_geojson_layer = {
					geoJson: o_geojson,
					style: o_style,
					type: "geojson"
				};
				a_objs_highlighted_mapfish_gj_layers.push(o_mapfish_geojson_layer);

			}

			return a_objs_highlighted_mapfish_gj_layers;
		},

		/**
		 * 
		 * @returns object {
		 * 	a_area_point_mapfish_gj_layers: "Array", 
		 * 	project_coords: "String"
		 * }
		 * 
		 * @summary
		 * returned project_coords example:  ex: "1 - X: -111111.1 - Y: -111111.2 \r\n2 - X: -222222.1 - Y: -222222.2 \r\n3 - X: -333333.1 - Y: -333333.2",
		 */
		f_get_tooldraw_area_points_mapfish_geojson_layers_array__and__project_coords_for_planta_localizacao: function ()
		{
			//let private_objs = this.private_objs;
			//let s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME;

			//the input has been validated, so there is only one geometry that is an area
			/*
			let o_mapfish_geojson_layer = a_tooldraw_mapfish_gj_layers[0];
			let o_gj_area_f = o_mapfish_geojson_layer.features[0];*/
			let o_gj_area_f = NSToolDraw.f_get_drawn_geometry_as_geo_json_feature();

			let a_area_coords = o_gj_area_f.geometry.coordinates[0];


			let o_geojson = {
				"type": "FeatureCollection",
				"features": []
			};

			let s_project_coords = "";
			let a_area_point_mapfish_gj_layers = [];
			let s_CONST_LINE_CHNAGE = "\r\n";
			for(let i=0; i<(a_area_coords.length-1); i++)
			{
				let a_point_i = a_area_coords[i];

				let o_gj_point_f = NSGeoJson.f_get_geojson_feature_point_from_coords(a_point_i);
				o_gj_point_f.properties = {};
				//o_gj_point_f.properties[s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME] = i+1; //Label for point
				let s_feature_label_value = i+1; //Label for point

				//to add style to point
				this.f_prepare_feature_for_style_standard(o_gj_point_f, s_feature_label_value);

				o_geojson.features.push(o_gj_point_f);


				//project coords:
				/*
				 	example: "1 - X: -111111.1 - Y: -111111.2 \r\n2 - X: -222222.1 - Y: -222222.2 \r\n3 - X: -333333.1 - Y: -333333.2"
				*/
				let a_xy = o_gj_point_f.geometry.coordinates;
				let i_dp = 1; // decimal places
				
				let a_xy_etrs89 = NSCRS.f_convert_xy_from_EPSG3857_to_ETRS89_PT_TM06_rounded_with_X_DP(a_xy, i_dp);
				let s_unit_prefix = " m";

				let s_xy_etrs89_x_formated = a_xy_etrs89[0] + s_unit_prefix;
				let s_xy_etrs89_y_formated = a_xy_etrs89[1] + s_unit_prefix;

				s_project_coords += s_feature_label_value + " - X: " + s_xy_etrs89_x_formated + " - Y: " +  s_xy_etrs89_y_formated + s_CONST_LINE_CHNAGE;

			}

			
			let o_style = this.f_get_mapfish_geojson_style_planta_localizacao_map02_area_points();

			let o_mapfish_geojson_layer = {
				geoJson: o_geojson,
				style: o_style,
				type: "geojson"
			};
			a_area_point_mapfish_gj_layers.push(o_mapfish_geojson_layer);

			if(s_project_coords.length > 0)
			{
				s_project_coords = 	s_project_coords.substring(0, (s_project_coords.length - s_CONST_LINE_CHNAGE.length) );
			}

			return {
				a_area_point_mapfish_gj_layers: a_area_point_mapfish_gj_layers, 
				project_coords: s_project_coords
			};

		},
		f_get_area_center_mapfish_geojson_layers_array_for_planta_localizacao: function ()
		{
			let o_geojson = {
				"type": "FeatureCollection",
				"features": []
			};

			//let a_center = NSPrintPrivate.private_objs.o_marker_struct.f_get_coords_a_xy();
			let a_center = NSToolDraw.f_get_drawn_polygon_center();

			//Avoiding Cache:
			let num = parseFloat(a_center[1]);
			num = num + ( (Math.floor(Math.random()*1000)) * 0.000000000000001);
			a_center[1] = num ;//num.toString();
			
			let o_gj_point_f = NSGeoJson.f_get_geojson_feature_point_from_coords(a_center);
			o_gj_point_f.properties = {};

			//to add style to point
			this.f_prepare_feature_for_style_standard(o_gj_point_f);

			o_geojson.features.push(o_gj_point_f);
			
			let o_style = this.f_get_mapfish_geojson_style_standard();

			let o_mapfish_geojson_layer = {
				geoJson: o_geojson,
				style: o_style,
				type: "geojson"
			};
			let a_map_center_mapfish_gj_layers = [];
			a_map_center_mapfish_gj_layers.push(o_mapfish_geojson_layer);
			return a_map_center_mapfish_gj_layers;

		},

		f_get_mapfish_geojson_style_standard: function()
		{
			let private_objs = this.private_objs;
			let s_CONST_STYLE_TYPE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_TYPE_PROPRIETY_NAME;
			let s_CONST_STYLE_TYPE_POINT_VALUE = private_objs.s_CONST_STYLE_TYPE_POINT_VALUE;
			let s_CONST_STYLE_TYPE_LINE_VALUE = private_objs.s_CONST_STYLE_TYPE_LINE_VALUE;
			let s_CONST_STYLE_TYPE_POLYGON_VALUE = private_objs.s_CONST_STYLE_TYPE_POLYGON_VALUE;
			let s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME;

			let s_style_prop_name_point = "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+s_CONST_STYLE_TYPE_POINT_VALUE+"']";	// "[style_type = 'point']";
			let s_style_prop_name_line = "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+s_CONST_STYLE_TYPE_LINE_VALUE+"']";	// "[style_type = 'line']";
			let s_style_prop_name_polygon = "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+s_CONST_STYLE_TYPE_POLYGON_VALUE+"']";	// "[style_type = 'polygon']";

			let o_style = {
				[s_style_prop_name_point]: {"symbolizers": [{
					"fillColor": "#ff0000",//"green",
					"strokeWidth": 2,
					"strokeColor": "#ff0000",//"red",
					"type": "point",
					"pointRadius": 8,//6,
					"strokeOpacity": 1
				}]},
				[s_style_prop_name_line]: {"symbolizers": [{
					"strokeWidth": 3,//4,
					"strokeColor": "#ff0000",//"#ffaaaa",
					"type": "line",
					"strokeOpacity": 1
				}]},
				[s_style_prop_name_polygon]: {"symbolizers": [{
					"fillColor": "#ffffff",//"green",
					"strokeWidth": 3,
					"fillOpacity": 0.2,
					"strokeColor": "#ff0000",//"blue",
					"type": "polygon",
					"strokeOpacity": 1
				}]},
				"*": {"symbolizers": [{
					"haloOpacity": "0.7",
					"labelXOffset": "-1.0",
					"fillOpacity": 0,
					"labelYOffset": "-10.0",
					"haloRadius": "3.0",
					"haloColor": "#aaaaaa",
					"label": "["+s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME+"]",	// "[prop_name_of_label_value]",
					"type": "text",
					"fontStyle": "normal",
					"fillColor": "#FF0000",
					"fontFamily": "sans-serif",
					"labelAlign": "cm",
					"fontSize": "12px",
					"labelRotation": "45",
					"fontColor": "#000000",
					"fontWeight": "bold"
				}]},
				"version": "2"
			};
			return o_style;
		},

		/**
		 * 
		 * @param {Array<Integer>} a_point_highlight_vertical_offsets,ex: [10,-20,5]
		 * @returns 
		 */
		f_get_mapfish_geojson_style_highlights: function(a_point_highlight_vertical_offsets)
		{
			let private_objs = this.private_objs;
			let s_CONST_STYLE_TYPE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_TYPE_PROPRIETY_NAME;
			let s_CONST_STYLE_TYPE_POINT_VALUE = private_objs.s_CONST_STYLE_TYPE_POINT_VALUE;
			let s_CONST_STYLE_TYPE_LINE_VALUE = private_objs.s_CONST_STYLE_TYPE_LINE_VALUE;
			let s_CONST_STYLE_TYPE_POLYGON_VALUE = private_objs.s_CONST_STYLE_TYPE_POLYGON_VALUE;
			let s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME;

			let s_style_prop_name_point = "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+s_CONST_STYLE_TYPE_POINT_VALUE+"']";	// "[style_type = 'point']";
			let s_style_prop_name_line = "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+s_CONST_STYLE_TYPE_LINE_VALUE+"']";	// "[style_type = 'line']";
			let s_style_prop_name_polygon = "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+s_CONST_STYLE_TYPE_POLYGON_VALUE+"']";	// "[style_type = 'polygon']";

			let o_style = {
				[s_style_prop_name_point]: {"symbolizers": [{
					"fillColor": "#ff0000",//"green",
					"fillOpacity": 0,
					"strokeWidth": 2,//2,
					"strokeColor": "#ff0000",//"red",
					"type": "point",
					"pointRadius": 11,//35,//8,//6,
					"strokeOpacity": 0.4,//1
				}]},
				[s_style_prop_name_line]: {"symbolizers": [{
					"strokeWidth": 3,//4,
					"strokeColor": "#ff0000",//"#ffaaaa",
					"type": "line",
					"strokeOpacity": 0.4,//1
				}]},
				[s_style_prop_name_polygon]: {"symbolizers": [{
					"fillColor": "#ffffff",//"green",
					"strokeWidth": 3,
					"fillOpacity": 0.2,
					"strokeColor": "#ff0000",//"blue",
					"type": "polygon",
					"strokeOpacity": 0.4,//1
				}]},
				"*": {"symbolizers": [{
					"haloOpacity": "0.7",
					"labelXOffset": "-1.0",
					"fillOpacity": 0,
					"labelYOffset": "-10.0",
					"haloRadius": "3.0",
					"haloColor": "#aaaaaa",
					"label": "["+s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME+"]",	// "[prop_name_of_label_value]",
					"type": "text",
					"fontStyle": "normal",
					"fillColor": "#FF0000",
					"fontFamily": "sans-serif",
					"labelAlign": "cm",
					"fontSize": "12px",
					"labelRotation": "45",
					"fontColor": "#000000",
					"fontWeight": "bold"
				}]},
				"version": "2"
			};


			// adding highlights with offsets
			if(a_point_highlight_vertical_offsets != null && a_point_highlight_vertical_offsets.length>0)
				a_point_highlight_vertical_offsets.forEach(i_offset => {
				
					let styleName = this.f_getOffsetStyleNameForPointHighlight(i_offset);
					let s_style_prop_name_point_highlight_with_offset  
						= "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+styleName+"']";	// "[style_type = 'point']";
					o_style[s_style_prop_name_point_highlight_with_offset] = 
						{"symbolizers": [{
							"fillColor": "#ff0000",//"green",
							"fillOpacity": 0,
							"strokeWidth": 4,//2,
							"strokeColor": "#ff0000",//"red",
							"type": "point",
							"pointRadius": 35,//8,//6,
							"strokeOpacity": 0.4,//1,
							"graphicYOffset": (i_offset * 2)
						}]};					
				});

			return o_style;

		},
		f_getOffsetStyleNameForPointHighlight: function (i_displacement) {
			const prefix = i_displacement < 0 ? "neg" : "";
			const key = `point_${prefix}${Math.abs(i_displacement)}`;
			return key;
		},

		f_get_mapfish_geojson_style_planta_localizacao_map02_area_points: function()
		{
			let private_objs = this.private_objs;
			let s_CONST_STYLE_TYPE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_TYPE_PROPRIETY_NAME;
			let s_CONST_STYLE_TYPE_POINT_VALUE = private_objs.s_CONST_STYLE_TYPE_POINT_VALUE;
			let s_CONST_STYLE_TYPE_LINE_VALUE = private_objs.s_CONST_STYLE_TYPE_LINE_VALUE;
			let s_CONST_STYLE_TYPE_POLYGON_VALUE = private_objs.s_CONST_STYLE_TYPE_POLYGON_VALUE;
			let s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME;

			let s_style_prop_name_point = "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+s_CONST_STYLE_TYPE_POINT_VALUE+"']";	// "[style_type = 'point']";
			let s_style_prop_name_line = "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+s_CONST_STYLE_TYPE_LINE_VALUE+"']";	// "[style_type = 'line']";
			let s_style_prop_name_polygon = "["+s_CONST_STYLE_TYPE_PROPRIETY_NAME+" = '"+s_CONST_STYLE_TYPE_POLYGON_VALUE+"']";	// "[style_type = 'polygon']";

			let o_style = {
				[s_style_prop_name_point]: {"symbolizers": [{
					"fillColor": "#ffffff",//"green",
					"strokeWidth": 1,
					"strokeColor": "#ff0000",//"red",
					"type": "point",
					"pointRadius": 7,//6,
					"strokeOpacity": 1
				}]},
				[s_style_prop_name_line]: {"symbolizers": [{
					"strokeWidth": 3,//4,
					"strokeColor": "#ff0000",//"#ffaaaa",
					"type": "line",
					"strokeOpacity": 1
				}]},
				[s_style_prop_name_polygon]: {"symbolizers": [{
					"fillColor": "#ffffff",//"green",
					"strokeWidth": 3,
					"fillOpacity": 0.2,
					"strokeColor": "#ff0000",//"blue",
					"type": "polygon",
					"strokeOpacity": 1
				}]},
				"*": {"symbolizers": [{
					"haloOpacity": "1.0",
					"labelXOffset": "0.0",
					"fillOpacity": 1.0,
					"labelYOffset": "0.0",
					"haloRadius": "1.0",
					"haloColor": "#ffffff",
					"label": "["+s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME+"]",	// "[prop_name_of_label_value]",
					"type": "text",
					"fontStyle": "normal",
					"fillColor": "#FF0000",
					"fontFamily": "sans-serif",
					"labelAlign": "cm",
					"fontSize": "9px",
					"labelRotation": "0",
					"fontColor": "#000000",
					"fontWeight": "normal"
				}]},
				"version": "2"
			};
			return o_style;
		},

		f_prepare_feature_for_style_standard: function(o_geo_json_feature, s_feature_label_value)
		{
			let private_objs = this.private_objs;
			let s_CONST_STYLE_TYPE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_TYPE_PROPRIETY_NAME;
			let s_CONST_STYLE_TYPE_POINT_VALUE = private_objs.s_CONST_STYLE_TYPE_POINT_VALUE;
			let s_CONST_STYLE_TYPE_LINE_VALUE = private_objs.s_CONST_STYLE_TYPE_LINE_VALUE;
			let s_CONST_STYLE_TYPE_POLYGON_VALUE = private_objs.s_CONST_STYLE_TYPE_POLYGON_VALUE;
			let s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME;
			
			if(o_geo_json_feature.properties == null)
			{
				o_geo_json_feature.properties = {};
			}

			let s_geom_type = o_geo_json_feature.geometry.type;
			if(NSGeoJson.Types.f_is_point(s_geom_type))
			{
				o_geo_json_feature.properties[s_CONST_STYLE_TYPE_PROPRIETY_NAME] = s_CONST_STYLE_TYPE_POINT_VALUE;
			}
			else if(NSGeoJson.Types.f_is_polyline(s_geom_type)
					|| NSGeoJson.Types.f_is_multipolyline(s_geom_type))
			{
				o_geo_json_feature.properties[s_CONST_STYLE_TYPE_PROPRIETY_NAME] = s_CONST_STYLE_TYPE_LINE_VALUE;
			}
			else if(NSGeoJson.Types.f_is_polygon(s_geom_type)
					|| NSGeoJson.Types.f_is_multipolygon(s_geom_type))
			{
				o_geo_json_feature.properties[s_CONST_STYLE_TYPE_PROPRIETY_NAME] = s_CONST_STYLE_TYPE_POLYGON_VALUE;
			}
			

			//ATENTION if this property is not added, feature will be incompatible with label style, and the feature wont appear!!! 
			o_geo_json_feature.properties[s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME] = (s_feature_label_value!=null)? s_feature_label_value : null;

		},

		f_prepare_feature_for_style_for_highlights: function(o_geo_json_feature,
			b_add_displacement_to_highlight_an_icon,
			verticalOffset, 
			s_feature_label_value)
		{
			let private_objs = this.private_objs;
			let s_CONST_STYLE_TYPE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_TYPE_PROPRIETY_NAME;
			let s_CONST_STYLE_TYPE_POINT_VALUE = private_objs.s_CONST_STYLE_TYPE_POINT_VALUE;
			let s_CONST_STYLE_TYPE_LINE_VALUE = private_objs.s_CONST_STYLE_TYPE_LINE_VALUE;
			let s_CONST_STYLE_TYPE_POLYGON_VALUE = private_objs.s_CONST_STYLE_TYPE_POLYGON_VALUE;
			let s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME = private_objs.s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME;
			
			if(o_geo_json_feature.properties == null)
			{
				o_geo_json_feature.properties = {};
			}

			let s_geom_type = o_geo_json_feature.geometry.type;
			if(NSGeoJson.Types.f_is_point(s_geom_type))
			{
				if(b_add_displacement_to_highlight_an_icon)
				{
					let s_STYLE_TYPE_POINT_HIGHLIGHT_WITH_OFFSET_VALUE = 
					this.f_getOffsetStyleNameForPointHighlight(verticalOffset);
					o_geo_json_feature.properties[s_CONST_STYLE_TYPE_PROPRIETY_NAME] = s_STYLE_TYPE_POINT_HIGHLIGHT_WITH_OFFSET_VALUE;
				}
				else
				{
					o_geo_json_feature.properties[s_CONST_STYLE_TYPE_PROPRIETY_NAME] = s_CONST_STYLE_TYPE_POINT_VALUE;
				}
			}
			else if(NSGeoJson.Types.f_is_polyline(s_geom_type)
					|| NSGeoJson.Types.f_is_multipolyline(s_geom_type))
			{
				o_geo_json_feature.properties[s_CONST_STYLE_TYPE_PROPRIETY_NAME] = s_CONST_STYLE_TYPE_LINE_VALUE;
			}
			else if(NSGeoJson.Types.f_is_polygon(s_geom_type)
					|| NSGeoJson.Types.f_is_multipolygon(s_geom_type))
			{
				o_geo_json_feature.properties[s_CONST_STYLE_TYPE_PROPRIETY_NAME] = s_CONST_STYLE_TYPE_POLYGON_VALUE;
			}
			

			//ATENTION if this property is not added, feature will be incompatible with label style, and the feature wont appear!!! 
			o_geo_json_feature.properties[s_CONST_STYLE_LABEL_VALUE_PROPRIETY_NAME] = (s_feature_label_value!=null)? s_feature_label_value : null;

		}
		



	},





	f_validate: function()
	{
		let private_objs = this.private_objs;
		let o_data_struct = private_objs.o_data_struct;
		
		//this.f_show_local_message("");
		let b_res = true;
		
		let o_template = o_data_struct.f_get_selected_template();
		
		let b_area_is_required = o_template.b_area_is_required;
		
		if(b_area_is_required)
		{
			let b_draw_polygon_is_active_and_an_area_is_drawn = NSToolDraw.f_draw_polygon_is_active_and_an_area_is_drawn();
			if(!b_draw_polygon_is_active_and_an_area_is_drawn)
			{
				b_res = false;
				this.f_show_local_message("A área não está devidamente marcada.");
				
				NSToolDraw.f_ensure_draw_polygon_is_active();
			}
		}			
		
		
		return b_res;
	},
    
    f_button_execute_is_enabled: function()
	{
		let e_button_execute = this.private_objs.e_button_print_execute;
		let b_is_enabled = NSControlsState.f_control_is_enabled(e_button_execute);
		
		return b_is_enabled;
	},
	f_button_execute_enable: function()
	{
		let e_button_execute = this.private_objs.e_button_print_execute;
        NSControlsState.f_control_enable(e_button_execute);
		
	},
	f_button_execute_disable: function()
	{
		let e_button_execute = this.private_objs.e_button_print_execute;
        NSControlsState.f_control_disable(e_button_execute);
		
		
	},

    f_show_scale_div: function()
	{
		this.private_objs.e_div_print_scale.style.display = '';
	},
	f_hide_scale_div: function()
	{
		this.private_objs.e_div_print_scale.style.display = 'none';
	},
	
	f_show_titulo_referencia_divs: function()
	{
		this.private_objs.e_div_print_titulo.style.display = '';
		this.private_objs.e_div_print_referencia.style.display = '';
	},
	f_hide_titulo_referencia_divs: function()
	{
		this.private_objs.e_div_print_titulo.style.display = 'none';
		this.private_objs.e_div_print_referencia.style.display = 'none';
	},

    f_show_local_message: function(s_message)
	{
		//this.private_objs.e_span_print_messages.innerHTML = "<b>" + s_message + "</b>";
        NSMessages.f_show_information(s_message);
	},
	f_show_local_message_error_invoking_service: function ()
	{
		//this.f_show_local_message("Erro ao invocar o serviço.");
        let s_message = NSPageLabels.f_get_label_text_by_internal_name("common_error_executing_service");
        NSMessages.f_show_error(s_message);
	},
	
    f_show_result_div: function()
	{
		this.private_objs.e_div_print_result.style.display = 'inline';
	},
	f_hide_result_div: function()
	{
		this.private_objs.e_div_print_result.style.display = 'none';
	},

    f_create_quickprint_button : function() {
        let s_print_button_excute_browser_print_tooltip = NSPageLabels.f_get_label_text_by_internal_name("print_button_excute_browser_print_tooltip");

        let s_html =
		`<button id="quickprint_button" type="button" class="btn btn-sm btn-outline-secondary" title="${s_print_button_excute_browser_print_tooltip}">
			${PrinterIcon}
		</button>`;
        
        NSFunctions.f_dom_elem_preappend_dom_childs_by_html(document.getElementById("header-main-buttons"), s_html);
        document.getElementById("quickprint_button").onclick = function()
        {
			window.print();
        };
	},

    //--------------------------------------------------------------------------------
    //objs section:
	objs: {
		
		init: function()
		{

        }
    }




};
